module.exports = __webpack_public_path__ + "static/media/pass.a5c8273d.png";